/* eslint-disable @typescript-eslint/naming-convention */

import type { ReactElement } from 'react'

import {
	docIcon,
	fileIcon,
	folderIcon,
	htmlIcon,
	linkIcon,
	pdfIcon,
	pictureIcon,
	pptIcon,
	sharepointLogo,
	videoIcon,
	youtubeIcon
} from '@assets'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ContentSource, ContentType } from '@types'

type AcceptedTypes = ContentType | 'video' | 'folder' | 'link' | 'file' | 'drive' | 'workspace'

const icons: Record<string, ReactElement> = {
	image: <img src={ pictureIcon } className="w-full h-full" />,
	pdf: <img src={ pdfIcon } className="w-full h-full" />,
	link: <img src={ linkIcon } className="w-full h-full" />,
	html: <img src={ htmlIcon } className="w-full h-full" />,
	folder: <img src={ folderIcon } className="w-full h-full" />,
	file: <img src={ fileIcon } className="w-full h-full" />,
	youtube: <img src={ youtubeIcon } className="w-full h-full" />,
	videoIcon: <img src={ videoIcon } className="w-full h-full" />,
	powerpoint: <img src={ pptIcon } className="w-full h-full" />,
	word: <img src={ docIcon } className="w-full h-full" />,
	excel: <FontAwesomeIcon icon="file-excel" />,
	drive: <FontAwesomeIcon icon="sitemap" className="text-blue-400" />,
	workspace: <img src={ sharepointLogo } className="w-full h-full" />,
	audio: <FontAwesomeIcon icon="podcast" />
}

export const typeIcons: Record<AcceptedTypes, ReactElement> = {
	'image/png': icons.image,
	'image/jpeg': icons.image,
	'text/html': icons.link,
	'text/plain': icons.link,
	'text/markdown': icons.file,
	'application/pdf': icons.pdf,
	'application/msword': icons.word,
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document': icons.word,
	'application/vnd.ms-excel': icons.excel,
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': icons.excel,
	'application/vnd.ms-powerpoint': icons.powerpoint,
	'application/vnd.openxmlformats-officedocument.presentationml.presentation': icons.powerpoint,
	video: icons.youtube,
	folder: icons.folder,
	drive: icons.drive,
	workspace: icons.workspace,
	file: icons.file,
	link: icons.link,
	'audio/mpeg': icons.audio,
	'audio/mp4': icons.audio,
	'audio/x-m4a': icons.audio
}

export function getContentIcon(type: AcceptedTypes, source?: ContentSource | undefined) {
	if (type === 'text/html' && source === 'web') {
		return icons.link
	}

	return typeIcons[type] ?? icons.file
}
